import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/solid';

const TOOL_ICONS = {
  miro: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/miro%20logo.jpeg',
  notion: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/notion_icon.png', // or .svg if you prefer
  slack: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets/slack-new-logo.svg',
  google: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//icons8-google-96.svg',
  pdf: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//pdf-icon.png',
  gitlab: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//gitlab-icon.png',
  peoplemetrics: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//peoplemetricsfyi_logo.png',
  youtube: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//youtube.png',
  openai: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//openailogo.png',
  bolt: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//Stackblitz%20Logo.jpeg',
  lovable: 'https://auth.openorg.fyi/storage/v1/object/public/web-assets//lovable.jpeg',
};

const ToolCallout = ({ tool, icon, label, href, description, bgColor }) => {
  const resolvedIcon = icon || (tool && TOOL_ICONS[tool]);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center px-5 py-4 rounded-lg border border-primary-light font-semibold transition shadow-md hover:shadow-lg hover:bg-primary-light/10 ${bgColor || 'bg-gray-900/60'}`}
      style={{ textDecoration: 'none' }}
    >
      {resolvedIcon ? (
        <img
          src={resolvedIcon}
          alt={`${tool || 'tool'} icon`}
          className="h-10 w-10 rounded-lg mr-4 object-contain shadow-md bg-gray-800"
          style={{ background: '#23272f' }}
        />
      ) : (
        <BookOpenIcon className="h-10 w-10 text-primary-light mr-4 bg-gray-800 rounded-lg p-1 shadow-md" />
      )}
      <div className="flex-1">
        <div className="text-primary-light text-lg font-bold mb-1">{label}</div>
        {description && <div className="text-gray-300 text-sm leading-snug">{description}</div>}
      </div>
      <svg className="h-5 w-5 ml-4 text-primary-light" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </a>
  );
};

export default ToolCallout; 